<template>
  <div class="w-100">
    <div v-if="isLoading" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
      <div v-if="errorLoad" class="py-3">
        <ErrorMessage :message="errorLoad" />
      </div>
      <template v-else>
        <div class="w-100 py-3" v-if="currentDeliveryPosition === ''">
          <p class="mb-0 body-2-2-1 w-100 text-center"><i>Please setup your delivery address first</i></p>
        </div>
        <template v-else>
          <div v-for="courier in list" class="w-100 mb-3 position-relative" @click="selectCourier(courier)">
            <div class="w-100 rounded p-3 border-form d-flex z-index-1026">
              <div style="width: 58px;height: 44px;" class="d-flex align-items-center justify-content-center rounded bg-white box-shadow-1">
                <img :src="courier.logo" width="40" />
              </div>
              <div class="pl-3 w-100">
                <p class="mb-0 body-2-4">{{ courier.courier_name }}</p>
                <p class="mb-0 body-2-4 text-green">{{ $formatCurrency(courier.price) }}</p>
              </div>
              <div class="d-flex align-items-center justify-content-center" style="width: 40px;">
                <svg v-if="selected.courier_code == courier.courier_code" width="26" height="27" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_553_23)">
                    <path
                      d="M13 26C20.1118 26 26 20.0991 26 13C26 5.88824 20.0991 0 12.9873 0C5.88824 0 0 5.88824 0 13C0 20.0991 5.90099 26 13 26Z"
                      class="fill-primary" />
                    <path
                      d="M11.5725 19.2324C11.1392 19.2324 10.7824 19.0539 10.451 18.6079L7.25197 14.6824C7.0608 14.4275 6.94609 14.1471 6.94609 13.854C6.94609 13.2804 7.39217 12.8088 7.9657 12.8088C8.33531 12.8088 8.61571 12.9235 8.93432 13.3441L11.5216 16.6833L16.9638 7.94021C17.2059 7.55786 17.5373 7.35394 17.8687 7.35394C18.4294 7.35394 18.952 7.73629 18.952 8.33531C18.952 8.61571 18.7863 8.90885 18.6334 9.17649L12.6432 18.6079C12.3755 19.0285 12.0059 19.2324 11.5725 19.2324Z"
                      fill="white" />
                  </g>
                  <defs>
                    <clipPath id="clip0_553_23">
                      <rect width="26" height="26.0128" fill="white" />
                    </clipPath>
                  </defs>
                </svg>  
              </div>
            </div>
            <div v-if="selected.courier_code == courier.courier_code" class="primary-overlay z-index-1025"></div>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex';
  import { get, post } from "@/services/index.js";
  import grabLogo from '@/assets/img/brand/GRAB.png';
  import gosendLogo from '@/assets/img/brand/GOJEK.png';

  export default {
    data(){
      return{
        isLoading: true,
        errorLoad: "",
        list: [],
        selected: {},
        updateBouncedTimer: null
      }
    },
    computed:{
      ...mapGetters(['getMerchant', 'getRestaurantDelivery', 'getRestaurantOrder', 'getRestaurantOrderQty']),
      currentDeliveryPosition(){
        if(this.$isEmpty(this.getRestaurantDelivery.detail)) return '';
        const { destination_position } = this.getRestaurantDelivery.detail 
        return `${destination_position[0]}_${destination_position[1]}`
      },
      deliveryAndProudct(){
        return `${this.currentDeliveryPosition}_${this.getRestaurantOrderQty}`
      }
    },
    watch:{
      deliveryAndProudct(){
        if(this.updateBouncedTimer) clearTimeout(this.updateBouncedTimer);
        this.updateBouncedTimer = setTimeout(() => {
          this.setupPage();
        }, 400);
      },
    },
    mounted(){
      if(this.$isNotEmptyV2(this.getRestaurantDelivery.detail)) this.setupPage();
    },
    methods:{
      ...mapMutations(['setRestaurantDeliveryCourier']),
      async setupPage(){
        try {
          this.isLoading = true
          this.errorLoad = ""
          await this.loadCourierList();
          this.updateSavedCourier()
        } catch (error) {
          this.errorLoad = error.message
        } finally {
          this.isLoading = false
        }
      },
      async loadCourierList(){
        try {

          const apiParams = this.getParamsCourierList();
          const apiResponse = await post("CORE_RESTO", "biteship/delivery-choices", apiParams);
          const { success, data, message } = apiResponse.data 
          if(!success) throw new Error(message);
          this.list = data.rates.map(courier => {
            let logo = null
            if(courier.courier_code === 'grab') logo = grabLogo;
            if(courier.courier_code === 'gojek') logo = gosendLogo;
            courier.logo = logo
            return courier;
          });
          
        } catch (error) {
          throw error;
        }
      },
      getParamsCourierList(){
        try {
          const products = this.getRestaurantOrder.cart
          const { destination_position } = this.getRestaurantDelivery.detail
          
          let productList = [];
          
          for(let productItem of products){
            const { product, variant, qty } = productItem
            if(variant.length == 0){
              productList.push({
                id: product.data.product_ga_pos_id,
                qty
              })
            }else{
              for(let variantItem of variant){
                productList.push({
                  id: variantItem.data.product_ga_pos_id,
                  qty: variantItem.qty
                })
              }
            }
          }

          return {
            merchant_id: this.getMerchant.id,
            lat: destination_position[0],
            long: destination_position[1],
            products: productList
          }
          
        } catch (error) {
          throw error;
        }
      },
      updateSavedCourier(){
        const { courier = {} } = this.getRestaurantDelivery
        if(this.$isEmpty(courier)) return;

        const selectedCourier = this.list.find(item => item.courier_code === courier.courier_code);
        const updatedCourier = selectedCourier ? selectedCourier : {}
        this.setRestaurantDeliveryCourier(updatedCourier);
        this.selected = updatedCourier;
      },
      selectCourier(courier){
        if(this.selected.courier_code === courier.courier_code) return;
        this.selected = courier;
        this.setRestaurantDeliveryCourier(courier);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/general/CourierSelection.vue